<template>
  <div class="wheel">
    <div class="swiper wheel_top">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in dataList" :key="index">
          <img :src="imgPath+item.file_path" @click="openUrl(item.link_url)" style="cursor: pointer;"/>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev left"></div>
      <div class="swiper-button-next right"></div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper/swiper-bundle";
import {GetBannerList} from "@/api/admin/common.js";

export default {
  name: "",
  data() {
    return {
      dataList: [],
      swiper: null,
      imgPath: window.apiObj.apiUrl
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      GetBannerList({}).then(data => {

        var list = data.data.result;
        if (list) {
          this.dataList = list.items;
          this.creSwiper();
        }
      });
    },
    openUrl(e) {
      var url = e;
      if (e) {
        window.open(url, "_blank");
      }
    },
    creSwiper() {
      this.$nextTick(() => {
        this.swiper = new Swiper(".wheel_top", {
          loop: true,
          autoplay: {
            delay: 3000
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }
        });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.wheel {
  img {
    width: 100%;
    // height: 332px;
  }

  --swiper-navigation-size: 0;

  .right {
    position: absolute;
    right: 0;
    top: 50%;
    width: 30px;
    height: 60px;
    // margin-top: -35px;
    background-image: url("/image/index/icon-slides.png");
    background-size: cover;
    background-position: -42px 0px;
    transform: translateY(-50%);
  }

  .left {
    position: absolute;
    width: 30px;
    height: 60px;
    left: 0px;
    top: 50%;
    // margin-top: -35px;
    background-image: url("/image/index/icon-slides.png");
    background-size: cover;
    background-position: left;
    transform: translateY(-50%);
  }
}

@media only screen and (max-width: 768px) {
  .wheel {
    .left {
      width: 20px;
      height: 40px;
    }

    .right {
      width: 20px;
      height: 40px;
      background-position: -28px 0px;
    }
  }
}
</style>
